var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpiValidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0847 12.1522C11.3673 12.4348 11.8195 12.4348 12.1021 12.1522L15.8891 8.36523C16.1717 8.08262 16.1717 7.63045 15.8891 7.34784L15.6065 7.06523C15.3239 6.78262 14.8717 6.78262 14.5891 7.06523L11.5934 10.1174L10.3217 8.84566C10.0391 8.56305 9.58689 8.56305 9.30429 8.84566L9.04994 9.10001C8.76733 9.38262 8.76733 9.83479 9.04994 10.1174L10.8304 11.8978L11.0847 12.1522Z",
    fill: "#0076A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8956 14.2434H7.04346V15.8825H17.8956V14.2434Z",
    fill: "#0076A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8956 17.4934H7.04346V19.1325H17.8956V17.4934Z",
    fill: "#0076A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8956 20.7434H7.04346V22.3825H17.8956V20.7434Z",
    fill: "#0076A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5739 2.99561H17.2739V4.63474H18.5739C19.4217 4.63474 20.1 5.313 20.1 6.16082V22.8347C20.1 23.6826 19.4217 24.3608 18.5739 24.3608H6.36517C5.51734 24.3608 4.83908 23.6826 4.83908 22.8347V6.16082C4.83908 5.313 5.51734 4.63474 6.36517 4.63474H7.66517V2.99561H6.36517C4.61299 2.99561 3.19995 4.40865 3.19995 6.16082V22.8347C3.19995 24.5869 4.61299 26 6.36517 26H18.5456C20.2978 26 21.7108 24.5869 21.7108 22.8347V6.16082C21.7391 4.43691 20.2978 2.99561 18.5739 2.99561Z",
    fill: "#0076A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76732 5.2H16.1717C16.3412 5.2 16.4543 5.0587 16.4543 4.91739V2.79783C16.4543 2.6 16.313 2.40217 16.1434 2.34565L13.8825 1.8087V1.41304C13.8825 0.621739 13.2325 0 12.4695 0C11.6782 0 11.0564 0.65 11.0564 1.41304V1.8087L8.79558 2.34565C8.59775 2.40217 8.48471 2.6 8.48471 2.79783V4.91739C8.48471 5.0587 8.62602 5.2 8.76732 5.2ZM12.4695 0.706522C12.8086 0.706522 13.063 0.96087 13.063 1.3C13.063 1.63913 12.8086 1.89348 12.4695 1.89348C12.1304 1.89348 11.876 1.63913 11.876 1.3C11.876 0.98913 12.1304 0.706522 12.4695 0.706522Z",
    fill: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpiValidIcon);
export default __webpack_public_path__ + "static/media/npi_valid_icon.7e9a174bbdda3ca32dbe95863e3e0f3d.svg";
export { ForwardRef as ReactComponent };